import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["id", "data-cy", "type", "data-active", "disabled", "aria-labelledby"];
import BaseIcon from "@vueEntry/UIKitComponents/BaseIcon.vue";
import StaticSpinner from "@vueEntry/StaticSpinner.vue";
import { ref, onBeforeMount } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    lazyLoadIcon: {
      type: Boolean,
      default: true
    },
    btnClass: {
      default: ""
    },
    iconName: {
      default: ""
    },
    iconNameHovering: {
      default: ""
    },
    iconClass: {
      default: "tw-mr-[5px]"
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    keepActive: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["mouseover", "mouseout", "click"],
  setup(__props) {
    var props = __props;
    var hover = ref(false);
    var currentIcon = ref("");
    onBeforeMount(() => {
      var _a;
      currentIcon.value = (_a = props.iconName) !== null && _a !== void 0 ? _a : "";
    });
    var handleMouseHover = () => {
      hover.value = true;
      if (props.iconNameHovering) {
        changeIcon(props.iconNameHovering);
      }
    };
    var handleMouseOut = () => {
      hover.value = false;
      if (props.iconNameHovering) {
        changeIcon(props.iconName);
      }
    };
    var changeIcon = newIconName => {
      currentIcon.value = newIconName;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("button", {
        id: _ctx.$attrs.id,
        "data-cy": _ctx.$attrs['data-cy'],
        type: _ctx.$attrs.type,
        class: _normalizeClass([{
          'tw-btn': !_ctx.isEmpty,
          'tw-btn-empty': _ctx.isEmpty,
          'active tw-font-medium': _ctx.keepActive,
          'tw-flex tw-items-center tw-justify-center': _ctx.iconName || _ctx.isLoading
        }, _ctx.btnClass]),
        style: _normalizeStyle(_ctx.$attrs.style),
        "data-active": _ctx.keepActive,
        disabled: _ctx.isLoading || _ctx.disabled,
        "aria-labelledby": _ctx.$attrs.id,
        onMouseover: _cache[0] || (_cache[0] = _withModifiers($event => {
          handleMouseHover();
          _ctx.$emit('mouseover', $event);
        }, ["stop"])),
        onMouseout: _cache[1] || (_cache[1] = _withModifiers($event => {
          handleMouseOut();
          _ctx.$emit('mouseout', $event);
        }, ["stop"])),
        onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('click', $event))
      }, [_ctx.iconName && !_ctx.isLoading ? (_openBlock(), _createBlock(BaseIcon, {
        key: _ctx.$attrs.id ? _ctx.$attrs.id : 'btn' + "-".concat(_ctx.iconName),
        "icon-name": currentIcon.value,
        "icon-class": _ctx.iconClass,
        "alt-attribute": "button icon",
        "lazy-loading": _ctx.lazyLoadIcon
      }, null, 8 /* PROPS */, ["icon-name", "icon-class", "lazy-loading"])) : _createCommentVNode("v-if", true), !_ctx.isLoading ? _renderSlot(_ctx.$slots, "default", {
        key: 1,
        hover: hover.value
      }) : _renderSlot(_ctx.$slots, "spinner", {
        key: 2
      }, () => [_createVNode(StaticSpinner, {
        color: _ctx.btnClass.includes('tw-btn-light') ? 'tw-stroke-black' : 'tw-stroke-white'
      }, null, 8 /* PROPS */, ["color"])])], 46 /* CLASS, STYLE, PROPS, NEED_HYDRATION */, _hoisted_1);
    };
  }
});